/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as HoverIcon } from "cms/assets/icons/arrow-forward.svg";

const SectionLinkCardsItem = (props) => {
    const item = props?.item;
    const scrollTargets = props?.scrollTargets ?? [];

    const icon = item?.icon;
    const iconSrcUrl = icon?.url;
    const iconSrcAlt = icon?.alt ?? "section-link-icon";
    const link = item?.link;
    const linkText = link?.text;

    const scrollSectionId = scrollTargets?.find((scrollTarget) => scrollTarget.sectionLinkHeading === linkText)?.id;

    const scrollToSection = () => {
        const element = document.getElementById(scrollSectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div
            className="section-link-cards-item"
            onClick={scrollToSection}
        >
            {iconSrcUrl &&
                <div className="section-link-icon-container">
                    <img
                        src={iconSrcUrl}
                        alt={iconSrcAlt}
                        className={`icon default`}
                    />
                    <HoverIcon
                        alt="arrow-icon"
                        className="icon hover"
                    />
                </div>
            }
            {linkText && <h3>{linkText}</h3>}
        </div>
    );
};

SectionLinkCardsItem.displayName = "SectionLinkCardsItem";
export { SectionLinkCardsItem };
